import EmailChangeModal from "./emailChangeModal";

export default EmailChangeModal;
